<template>
  <router-view />
</template>

<script setup>
import { useCompanyBrand } from '@/composables/useCompanyBrand';

const { loadCompanySettings } = useCompanyBrand();
loadCompanySettings();
</script>

<style scoped></style>
